import { useState, useEffect, useRef } from "react";

const CustomDropdown = ({
  options = [],
  placeholder = "Select User Type",
  onChange,
  defaultValue = "",
  value, // controlled value
  name = "",
  className = "",
  defaultClass = 'custom-select',
  readOnly = false,
}) => {
  // Initialize selectedOption with matching option from defaultValue or first option or null
  const [selectedOption, setSelectedOption] = useState(() => {
    if (defaultValue) {
      return options.find((opt) => opt.value === defaultValue) || null;
    }
    return options[0] || null;
  });

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Update selectedOption when controlled `value` changes
  useEffect(() => {
    if (value !== undefined) {
      const matched = options.find((opt) => opt.value === value);
      if (matched) {
        setSelectedOption(matched);
      }
    }
  }, [value, options]);

  const handleSelect = (option, index) => {
    if (index === 0) return; // prevent selecting placeholder option
    if (readOnly) return;
    setSelectedOption(option);
    setIsOpen(false);
    if (onChange) {
      onChange(option.value);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Handle visibility with transition cleanup
  useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => {
        const element = dropdownRef.current?.querySelector(".select-items");
        if (element) {
          element.style.visibility = "hidden";
        }
      }, 300); // Match CSS transition duration
      return () => clearTimeout(timeout);
    } else {
      const element = dropdownRef.current?.querySelector(".select-items");
      if (element) {
        element.style.visibility = "visible";
      }
    }
  }, [isOpen]);

  return (
    <div className={`${defaultClass} ${className} ${isOpen ? "open" : ""}`} ref={dropdownRef}>
      <div
        className={`form-control ${readOnly ? "disabled-option" : ""}`}
        onClick={() => {
          if (readOnly) return;
          setIsOpen(!isOpen);
        }}
      >
        {selectedOption?.color && (
          <span className="priority-icon" style={{ background: selectedOption.color }}></span>
        )}
        {selectedOption ? selectedOption.label : placeholder}
      </div>

      {/* Dropdown options */}
      <div className="select-items">
        <div className="innerscrollbar">
        {options.map((option, index) => (
         
           <div
            key={option.value}
            onClick={() => handleSelect(option, index)}
            className={`option-item ${selectedOption?.value === option.value ? "same-as-selected" : ""}`}
          >
            {option.color && (
              <span className="priority-icon" style={{ background: option.color }}> </span>
            )}{" "}
            {option.label}
          </div>         
        ))}
        </div>
      </div>

      {/* Hidden input for form submission */}
      <input type="hidden" name={name} value={selectedOption?.value || ""} />
    </div>
  );
};

export default CustomDropdown;
